export const wordsSnow = [
"Эски|мос",
"Пин|гвин",
"Лед|ник",
"Льди|на",
"Тю|лень",
"Айс|берг",
"Мед|ведь",
"Ко|рабль",
"Ры|ба",
"Суг|роб",
"Пур|га",
"По|люс",
"Оке|ан",
"Сия|ние",
"Упряж|ка",
"Аль|батрос",
"Иг|лу"];